import { queryOptions } from "@tanstack/react-query"

import { api } from "@/http/api-client"
import type { TListCategoriesResponse } from "./types"

export type TListCategoriesParams = {
  organizationSlug: string
}

export function listCategories(params: TListCategoriesParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TListCategoriesResponse>(
    `/finances/categories?${searchParams.toString()}`,
  )
}

export const categoriesQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ["finance-categories", orgSlug],
    queryFn: async () => {
      const response = await listCategories({
        organizationSlug: orgSlug,
      })
      if (response.error) {
        throw new Error(response.error.message)
      }
      return response.data
    },
  })
